export default {"src":"/_next/static/media/qr-code-app-store.b5f30056.svg","height":984,"width":984,"blurWidth":0,"blurHeight":0};